import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider';
import { useProfile } from '../../hooks/api-hooks';

const navigation = [
  { to: '/admin', label: 'Tổng quan', end: true },
  { to: '/admin/khoa-hoc', label: 'Khóa học & skill' },
  { to: '/admin/don-hang', label: 'Đơn hàng & giao dịch' },
  { to: '/admin/hoc-vien', label: 'Học viên' },
  { to: '/admin/workshop', label: 'Workshop' },
  { to: '/admin/trang-chu', label: 'Quản lý trang chủ' },
  { to: '/admin/voucher', label: 'Voucher' },
  { to: '/admin/ma-kich-hoat', label: 'Mã kích hoạt' },
] as const;

export function AdminDashboardLayout() {
  const { signOut } = useAuth();
  const profile = useProfile();

  return (
    <div className="admin-app">
      <a className="skip-link" href="#admin-main">Chuyển đến nội dung quản trị</a>
      <aside className="admin-sidebar">
        <div>
          <NavLink to="/admin" className="admin-brand">huytkd_ai</NavLink>
          <span className="admin-brand-note">Bảng điều khiển</span>
        </div>

        <nav className="admin-nav" aria-label="Điều hướng quản trị">
          {navigation.map((item) => (
            <NavLink key={item.to} to={item.to} end={'end' in item && item.end}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="admin-account">
          <span>{profile.data?.email}</span>
          <NavLink to="/">Về cửa hàng</NavLink>
          <button type="button" className="link-button" onClick={() => void signOut()}>
            Đăng xuất
          </button>
        </div>
      </aside>

      <main className="admin-main" id="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
